import { render } from "./feedbackSubmit.vue?vue&type=template&id=7a7d1146&scoped=true&ts=true"
import script from "./feedbackSubmit.vue?vue&type=script&lang=ts"
export * from "./feedbackSubmit.vue?vue&type=script&lang=ts"

import "./feedbackSubmit.vue?vue&type=style&index=0&id=7a7d1146&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7d1146"]])

export default __exports__